import { Component, OnInit, input, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentService, ApKeyOverridePipe, ApContentPipe } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApEmailInputComponent } from '@ap/input/email';
import { ApPhoneInputComponent, PhoneNumberFormat } from '@ap/input/phone';

import content from './contact-details.content.json';
import { ContactDetailsForm } from './contact-details.model';

/** This component can be used to enter/show details about contact properties email-address and phone-number */
@Component({
    selector: 'ap-contact-details',
    templateUrl: './contact-details.component.html',
    styleUrls: ['../personal-details.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, ApEmailInputComponent, ApPhoneInputComponent, ApContentPipe, ApKeyOverridePipe]
})
export class ApContactDetailsComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    /**
     * Required - The form group to bind to see {@link ApContactDetailsService}.
     */
    public readonly contactDetailsForm = input.required<FormGroup<ContactDetailsForm>>();

    /**
     * keymap for content overrides
     */
    public readonly contentKeyMap = input<{
        [contentKey: string]: string;
    }>();

    /**
     * Formatting of the phone number.
     * Can be NL_PHONE, NL_MOBILE or INTERNATIONAL
     */
    public readonly numberFormat = input<PhoneNumberFormat>(PhoneNumberFormat.NL_PHONE);

    /**
     * Extra messages for the email field
     */
    public readonly extraMessagesEmail = input<ErrorMessages>({});

    /**
     * Extra messages for the phone field
     */
    public readonly extraMessagesPhone = input<ErrorMessages>({});

    protected errorMessagesEmail: ErrorMessages;
    protected errorMessagesPhone: ErrorMessages;

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.setErrorMessages();
    }

    private getErrorMessage(field: string, error: string): string {
        return this.contentService.get(new ApKeyOverridePipe().transform(`contact.details.${field}.error.${error}`, this.contentKeyMap()));
    }

    private setErrorMessages(): void {
        const requiredEmail = this.getErrorMessage('emailAddress', 'required');
        const incorrectEmail = this.getErrorMessage('emailAddress', 'pattern');
        this.errorMessagesEmail = { required: requiredEmail, incorrect: incorrectEmail, ...this.extraMessagesEmail() };
        const requiredPhone = this.getErrorMessage('phoneNumber', 'required');
        const incorrectPhone = this.getErrorMessage('phoneNumber', 'pattern');
        this.errorMessagesPhone = { required: requiredPhone, incorrect: incorrectPhone, ...this.extraMessagesPhone() };
    }
}
